import { axios } from '@Root/API'

export const getRulesPermissions = () => {
	return axios.get(`get-permissions/rules`)
}
